import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import EmersonNav from './EmersonNav';
import SideMenu from './SideMenu';

function  EmersonHeader() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

 

    return (
        <div>
            <header className={`emerson-header ${isSticky ? 'sticky' : ''}`}>
                <div className="emerson-header-container">
                    {/* Logo Section */}
                    <div className="emerson-header-logo">
                        <Link to="/">
                            <img src="/assets/images/logo/logo.png" alt="Company Logo" />
                        </Link>
                    </div>

                    {/* Navigation Section */}
                    <div className="emerson-header-nav">
                        <EmersonNav />
                    </div>

                    {/* Utility Icons Section */}
                    <div className="emerson-header-utilities">
               
                           
                           <Link className="rts-btn btn-primary-2 menu-block-none" to={'/contactus'}>
                              Contact us
                           </Link>
                           <button
                               id="menu-btn" onClick={toggleSidebar}
                               className="menu rts-btn btn-primary-alta ml--20 emerson-mobile-menu-btn"
                           >
                               {/* <img
                                   className="menu-dark"
                                   src="assets/images/icon/menu.png"
                                   alt="Menu-icon"
                               /> */}
                               <img
                                   className="menu-light"
                                   src="/assets/images/icon/menu-light.png"
                                   alt="Menu-icon"
                               />
                           </button>
                  

                       
                    </div>
                </div>
            </header>

        

            <SideMenu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </div>
    );
}

export default EmersonHeader;

